import React from 'react';
import RenderSearchResultGrid from './RenderSearchResultGrid';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { RequestState } from '../utils/useRequestState';
import { OrganizationSuggestionsResponse } from '../../../store/signup/types';
import SearchResult from './SearchResult';
import ZeroSearchResults from './ZeroSearchResults';

const list = [0, 0, 0, 0, 0, 0, 0, 0];
export const minSearchCardHeight = 175;
export const searchCardBorderRadius = 10;

export const shadow = '0px 0px 8px rgba(131, 131, 131, 0.3)';
const useStyles = makeStyles(() =>
    createStyles({
        loadingStyles: {
            width: '100%',
            minHeight: minSearchCardHeight,
            border: '1px solid #e3e3e3',
            borderRadius: searchCardBorderRadius,

            animation: `$loading-an 1.5s`,
            animationFillMode: 'forwards',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            background:
                'linear-gradient(to right, #EEEEED 17%, #dddddd 41%, #eeeeee 65%)',
            backgroundSize: '916px 104px',
        },

        '@keyframes loading-an': {
            '0%': {
                backgroundPosition: '-468px 0',
            },
            '100%': {
                backgroundPosition: '468px 0',
            },
        },
    }),
);

const RenderLoading: React.FC<{ data: number }> = () => {
    const { loadingStyles } = useStyles();
    return <div className={loadingStyles} />;
};

const SearchLoading: React.FC<{
    term: string;
    total: number;
    requestStatus: RequestState<OrganizationSuggestionsResponse[]>;
}> = ({ requestStatus, total, term }) => {
    if (
        requestStatus.type === 'REQUEST_START' ||
        requestStatus.type === 'REQUEST_INIT'
    ) {
        return (
            <RenderSearchResultGrid
                list={list}
                RenderComponent={RenderLoading}
            />
        );
    }
    if (total > 0 && requestStatus.type === 'REQUEST_SUCCESS') {
        return (
            <RenderSearchResultGrid
                list={requestStatus.data}
                RenderComponent={SearchResult}
            />
        );
    }
    return <ZeroSearchResults term={term} />;
};

export default SearchLoading;
